import React from "react";
import {Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import {formatFullDateTime, getElapsedLabel} from "./ticketUtils";

export const TicketElapsedTime = ({ticket}) => {
    const {t} = useTranslation(["tickets"]);
    const endKey = ticket.closedAt ? "closedAt" : ticket.cancelledAt ? "cancelledAt" : null;

    const renderEntry = (key, date) => (
        <div key={key}>
            <div>{t(`elapsed.${key}`, {ns: "tickets"})}</div>
            <div>{formatFullDateTime(date)}</div>
        </div>
    );

    const title = (
        <>
            {renderEntry("createdAt", ticket.createdAt)}
            {endKey && <div style={{marginTop: 8}}>{renderEntry(endKey, ticket[endKey])}</div>}
        </>
    );

    return (
        <Tooltip title={title}>
            <span>{getElapsedLabel(ticket, t)}</span>
        </Tooltip>
    );
};
